import React from "react";
import { footerNav } from "../../constants/footer";
import {
  BsLinkedin,
  BsTwitter,
  BsFacebook,
  BsYoutube,
  BsInstagram,
  BsTiktok,
} from "react-icons/bs";
import { applestore, googleplay } from "../../assets/images";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <div className="w-full bg-[#D9D9D9]">
      <div className="w-full md:w-4/5 flex flex-col gap-8 mx-auto p-5 md:p-[64px] justify-around">
        <div className="flex flex-wrap gap-[60px]">
          <div className="flex flex-wrap md:flex-nowrap  gap-12">
            {footerNav.map((nav, index) => (
              <div className="w-[20%] flex flex-col gap-2 md:gap-6" key={index}>
                <div className="text-black font-Inter text-[15px] md:text-[18px] capitalize leading-7  font-bold">
                  {nav.head}
                </div>
                {nav.links.map((link, index) => (
                  <div
                    className="text-white text-[13px] md:tex-[16px] flex flex-col gap-3 font-normal leading-4 cursor-pointer"
                    key={index}
                  >
                    <Link to={link.path} className="px-2 cursor-pointer">
                      {link.name}
                    </Link>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col-reverse gap-9 md:gap-0 md:flex-row md:justify-between">
          <div className="flex gap-5 mx-auto md:mx-0 ">
            <BsLinkedin color="black" size={20} className="cursor-pointer " />
            <BsTwitter color="black" size={20} className="cursor-pointer" />
            <BsFacebook color="black" size={20} className="cursor-pointer" />
            <BsYoutube color="black" size={20} className="cursor-pointer" />
            <BsInstagram color="black" size={20} className="cursor-pointer" />
            <BsTiktok color="black" size={20} className="cursor-pointer" />
          </div>
          <div className="flex flex-col justify-start items-start  md:justify-end md:items-end">
            <div className="flex flex-col  gap-6 md:gap-[46px]">
              <div className="text-black font-Poppins text-[36px] font-normal ">
                Ecomoto
              </div>
              <div className="flex flex-col gap-5 ">
                <div className="flex gap-5 ">
                  <img src={applestore} alt="" className="cursor-pointer" />
                  <img src={googleplay} alt="" className="cursor-pointer" />
                </div>
                <div className="text-black text-[12px] font-normal leading-4">
                  © 2023 Ecomoto Terms & Conditions
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
